/* @flow */

import { rem } from 'polished';
import { baseFontSize } from '@braindate/ui/lib/token/typography';

export default {
  playerWrapper: {
    position: 'relative',
    paddingTop: '56.25%' /* Player ratio: 100 / (1280 / 720) */,
    marginBottom: rem(30, baseFontSize),
    marginTop: rem(20, baseFontSize),
  },
  player: {
    position: 'absolute',
    top: 0,
    left: 0,
  },
};
